<template>
  <div id="TranshipmentEvaluation">
    <v-dialog v-model="open" persistent max-width="500">
      <v-card>
        <v-card-text class="d-flex flex-column">
          <div class="text-center">
            <h1 class="py-5">Avaliação do Transbordo</h1>
            <span>Escreva abaixo a avaliação do transbordo</span>
          </div>

          <v-row>
            <v-col cols="12">
              <v-textarea v-model="evaluation" counter label="Avaliação" :rules="rules"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="close()"> Cancelar </v-btn>
          <v-btn
            :loading="isButtonLoading"
            :disabled="isButtonDisable"
            color="success"
            class="flex-grow-1"
            large
            @click="handleTranshipmentEvaluationCreation()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :type="errorsType" :errors="errors" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MessagesError from '../MessagesError.vue';

export default {
  name: 'TranshipmentEvaluation',
  components: {
    MessagesError
  },
  props: {
    open: {
      defalut: () => false,
      type: Boolean
    },
    transhipmentId: {
      default: null,
      type: String
    }
  },

  data: () => ({
    evaluation: '',
    isButtonLoading: false,
    errorsType: 'success',
    errors: [],
    rules: [(v) => v.length <= 250 || 'Máximo de 250 carecteres']
  }),

  computed: {
    isButtonDisable() {
      const length = this.evaluation.length;
      if (length > 0 && length <= 250) {
        return false;
      }
      return true;
    }
  },

  methods: {
    ...mapActions('TranshipmentStore', ['saveTranshipmentEvaluation']),

    async handleTranshipmentEvaluationCreation() {
      try {
        this.isButtonLoading = true;
        const data = await this.saveTranshipmentEvaluation({
          evaluation: this.evaluation,
          transhipmentId: this.transhipmentId
        });
        if (data.success) {
          this.errorsType = 'success';
          this.errors = ['Avaliação salva com sucesso!'];
        } else {
          this.errorsType = 'error';
          const { errors } = data;
          this.errors = errors;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.close();
        this.$emit('shouldUpdateEvaluations');
        this.isButtonLoading = false;
      }
    },

    close() {
      this.evaluation = '';
      this.$emit('closeEvaluation');
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-input .v-text-field__details {
  display: flex;
  padding: 4px;
}
</style>
